const variants = [
        {
            title: 'Студент на 1 год',
            amoLeadDurationValue: '1 год',
            price: 500,
            leadPeriodYears: 1,
            amoLeadStatusId: 11949397,
            discountPossible: false,
        },
        {
            title: 'На 1 год',
            amoLeadDurationValue: '1 год',
            price: 5000,
            leadPeriodYears: 1,
            amoLeadStatusId: 11949397,
            discountPossible: true,
            groupRequestPossible: true,
        },
        {
            title: 'На 3 года',
            amoLeadDurationValue: '3 года',
            price: 10000,
            leadPeriodYears: 3,
            amoLeadStatusId: 11957728,
            discountPossible: true,
            groupRequestPossible: true,
        },
        {
            title: 'Пожизненно',
            amoLeadDurationValue: 'Бессрочно',
            price: 50000,
            leadPeriodYears: 100,
            amoLeadStatusId: 11950357,
            discountPossible: false,
        },
];

const todayDt = require('../format/utcDate')( new Date() );

// Начиная с 2022-03-15 все цены увеличены вдвое
if (todayDt > '2022-03-14') {
    variants.forEach(v => {
        v.price = v.price * 2;
    });
}

export const PROLONG_VARIANTS = variants;

export const LEAD_MEMBERSHIP_DURATION_ID      = '1025383'; // «Срок членства»
export const LEAD_MEMBERSHIP_LASTDATE_ID      = '1089782'; // «Дата окончания» сделки
export const LEAD_MEMBERSHIP_STARTDATE_ID     = '1010953'; // «Дата начала» сделки
export const LEAD_SUCCESS_DONE_STATUS_ID      = 142;
export const CONTACT_MEMBERSHIP_END_DATE_ID   = '1940246';
export const CONTACT_MEMBERSHIP_START_DATE_ID = '1089786';
